import { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import SupportWidget from '../SupportWidget';

// <Toaster/> now lives once at the App root (src/App.jsx) so public pages
// outside this layout (Login, etc.) get toast rendering too -- not mounted
// here anymore to avoid a duplicate instance.
export const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(p => !p)} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar onMenuClick={() => setCollapsed(p => !p)} />
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
      <SupportWidget />
    </div>
  );
};
